/**
 * Universidad de La Laguna
 * Escuela Superior de Ingeniería y Tecnología
 * Grado en Ingeniería Informática
 * Programación de Aplicaciones Interactivas
 *
 * @author Jose Angel Portillo Garcia
 * @author Alejandro Feo Martin
 * @author Kyliam Gabriel Chinea Salcedo
 * @since Apr 29 2026
 * @desc Predefined color for the educational purpose of this project
 */

/**
 * Enum for hexadecimal color constants compatible with Phaser (0xRRGGBB).
 * Organized by color tones following Google's TypeScript Style Guide.
 */
export enum ColorName {
  // --- ACHROMATIC ---
  WHITE = 0xFFFFFF,
  SILVER = 0xC0C0C0,
  GRAY = 0x808080,
  BLACK = 0x000000,
  // --- REDS & PINKS ---
  RED = 0xFF0000,
  CRIMSON = 0xDC143C,
  PINK = 0xFFC0CB,
  HOT_PINK = 0xFF69B4,
  // --- ORANGES & YELLOWS ---
  ORANGE = 0xFFA500,
  GOLD = 0xFFD700,
  YELLOW = 0xFFFF00,
  // --- GREENS ---
  LIME = 0x00FF00,
  GREEN = 0x008000,
  FOREST_GREEN = 0x228B22,
  OLIVE = 0x808000,
  // --- BLUES & CYANS ---
  CYAN = 0x00FFFF,
  SKY_BLUE = 0x87CEEB,
  BLUE = 0x0000FF,
  NAVY = 0x000080,
  // --- PURPLES ---
  PURPLE = 0x800080,
  MAGENTA = 0xFF00FF,
  // --- BROWNS ---
  BROWN = 0xA52A2A,
  CHOCOLATE = 0xD2691E,
}